export default "__VITE_ASSET__BIRmrwrG__"